module.exports = __webpack_public_path__ + "img/区域切除.f514ce67.svg";